import { styled, Theme } from "@mui/material";
import { useState } from "react";
import McpDrawer from "./drawer";
import McpBody from "./body";
import McpHeader from "./header";

//Entry
export default function HomeLayout() {
    const [open, setOpen] = useState(false);
    const [hover, setHover] = useState(false);

    return <>
        <McpHeader open={open} setOpen={setOpen}/>
        <McpDrawer open={open} hover={hover} setOpen={setOpen} setHover={setHover}/>
        <McpBody open={open}/>
    </>
}

//Constants/Utils, NO TOCAR SI NO ES NECESARIO
export const minDrawerThreshold = "lg";

export const drawerWidth = 250;
export const drawerClosedWidth = 60;

export const HeaderPad = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

export const openTransition = (theme:Theme)=>theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.easeOut,
    duration: theme.transitions.duration.enteringScreen,
})

export const closeTransition = (theme:Theme)=>theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
})